import React from "react";
import Image from "next/image";
import {
  COMMISSION_ARROW,
  COMMISSION_LINE,
  COMMISSION_SLINE,
  COMMISSION_TRIANGLE,
  COMMISSION_UP_ARROW,
} from "@/cdn";
import type { TProductInfo } from "@/typings";
import "./index.scss";

const classPrefix = "yfm-product-detail-commission";

interface ProductCommissionProps {
  productInfo: TProductInfo | null;
}

const ProductCommission: React.FC<ProductCommissionProps> = ({
  productInfo,
}) => {
  return (
    <div className={classPrefix}>
      <div className={`${classPrefix}__commission-box`}>
        <Image
          className={`${classPrefix}__img-arrow`}
          width={0}
          height={0}
          src={COMMISSION_ARROW}
          alt=""
        />
        <Image
          className={`${classPrefix}__img-line`}
          width={0}
          height={0}
          src={COMMISSION_LINE}
          alt=""
        />
        <Image
          className={`${classPrefix}__img-triangle`}
          width={0}
          height={0}
          src={COMMISSION_TRIANGLE}
          alt=""
        />
        <Image
          className={`${classPrefix}__img-sline`}
          width={0}
          height={0}
          src={COMMISSION_SLINE}
          alt=""
        />
        <div className={`${classPrefix}__commission-left-title`}>
          Public commission: {productInfo?.plan_commission_rate_str ?? "--"}
        </div>
        <div className={`${classPrefix}__commission-right-title`}>
          YooFinds commission
        </div>
        <div className={`${classPrefix}__commission-right-value`}>
          <Image
            className={`${classPrefix}__img-up-arrow`}
            width={0}
            height={0}
            src={COMMISSION_UP_ARROW}
            alt=""
          />
          <span>
            {productInfo?.creator_commission_rate
              ? productInfo?.creator_commission_rate / 100
              : "--"}
          </span>
          <small>%</small>
        </div>
      </div>
    </div>
  );
};

export default ProductCommission;
